import React from "react";

import Button from "../../shared/Button";
import CardSmall from "../../shared/CardSmall";

import cursor from "../../assets/icons/cursor.svg";
import watch from "../../assets/icons/watch.svg";
import hearth from "../../assets/icons/hearth.svg";
import design from "../../assets/icons/design.svg";

import "./Tools.css";

const Tools = (props) => {
  return (
    <div className="section-tools">
      <h2 className="section-title" style={{textAlign: 'center'}}>
        We design tools to unveil your superpowers
      </h2>
      <div className="tools-item-wrapper">
        <CardSmall
          image={cursor}
          card_title="First click tests"
          card_text="While most people enjoy
            casino gambling,"
        />
        <CardSmall
          image={design}
          card_title="Design surveys"
          card_text="Sports betting, lottery and bingo playing for the fun"
        />
        <CardSmall
          image={hearth}
          card_title="Preference tests"
          card_text="The Myspace page defines
            the individual."
        />
        <CardSmall
          image={watch}
          card_title="Five second tests"
          card_text="Personal choices and the overall personality of the person. "
        />
      </div>
      <Button btn="Sign Up now" />
    </div>
  );
};

export default Tools;
